<template>
  <div class="video-content">
    <video
      x5-video-player-type="h5"
      webkit-playsinline="true"
      x5-video-orientation="portraint"
      :poster="poster"
      preload="true"
      controls
      :src="path" alt=""></video>
    <div class="content-body">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoContent',
  props: {
    path: {
      require: true
    },
    poster: {
      require: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './VideoContent.scss';
</style>